import { useEffect } from 'react';

export const useMobileKeyboard = () => {
  useEffect(() => {
    // Only run on mobile devices
    if (typeof window === 'undefined') return;

    // Try Visual Viewport API first (most reliable for mobile)
    if (window.visualViewport) {
      const viewport = window.visualViewport;
      const initialHeight = window.innerHeight;

      const handleViewportResize = () => {
        const currentViewportHeight = viewport.height;
        const heightDiff = initialHeight - currentViewportHeight;

        if (heightDiff > 150) {
          document.body.classList.add("keyboard-open");
        } else {
          document.body.classList.remove("keyboard-open");
        }
      };

      // Also listen to input focus events
      const handleFocus = () => {
        setTimeout(handleViewportResize, 300);
      };

      const handleBlur = () => {
        setTimeout(handleViewportResize, 300);
      };

      viewport.addEventListener('resize', handleViewportResize);
      viewport.addEventListener('scroll', handleViewportResize);
      
      // Add focus listeners to all inputs
      document.addEventListener('focusin', handleFocus);
      document.addEventListener('focusout', handleBlur);

      return () => {
        viewport.removeEventListener('resize', handleViewportResize);
        viewport.removeEventListener('scroll', handleViewportResize);
        document.removeEventListener('focusin', handleFocus);
        document.removeEventListener('focusout', handleBlur);
        document.body.classList.remove("keyboard-open");
      };
    } else {
      // Fallback for browsers without Visual Viewport API
      const initialHeight = window.innerHeight;

      const handleResize = () => {
        const currentHeight = window.innerHeight;
        const isKeyboardOpen = currentHeight < initialHeight - 150;

        if (isKeyboardOpen) {
          document.body.classList.add("keyboard-open");
        } else {
          document.body.classList.remove("keyboard-open");
        }
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
        document.body.classList.remove("keyboard-open");
      };
    }
  }, []);
};
